import moment from 'moment';
import { EMARPOLDocuments, TMARPOLTank } from '../../marpol/@types';
import {
    ECRBRecordCode,
    ECRBRecordState,
    TCRBCommonData,
    TCRBCommonFields,
    ESubstanceCategories,
} from '../@types';
import { TCRBPlace } from '../@types';

export type TCRBItem1 = {
    placeOfBallast: TCRBPlace;
};

export type TCRBItem2 = {
    tanks: TCRBItem2Tank[];
};

export type TCRBItem2Tank = {
    selectedTank: TMARPOLTank;
    transferQuantity: number;
    newQuantity: number;
    substance: string;
    catgeory: ESubstanceCategories;
};

export type TCRBItem2P2 = {
    totalLoadedQuantityOfTanks: number;
};

export type TCRBItem2P3 = {
    startDate: string;
    startTime: string;
    endDate: string;
    endTime: string;
};

export type TCRBA1 = TCRBCommonFields &
    TCRBCommonData & {
        id: string;
        recordCode: ECRBRecordCode.CRBA;
        item1: TCRBItem1;
        item2: TCRBItem2;
        item2P2: TCRBItem2P2;
        item2P3: TCRBItem2P3;
    };

export type TCRBA = TCRBA1;

const CRBA_DEFAULTS: {
    A: TCRBA1;
} = {
    A: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.CRB,
        state: ECRBRecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item1: {
            placeOfBallast: {
                place: 'IN_PORT',
                portName: '',
            },
        },
        item2: {
            tanks: [],
        },
        item2P2: {
            totalLoadedQuantityOfTanks: 0,
        },
        item2P3: {
            startDate: '',
            startTime: '',
            endDate: '',
            endTime: '',
        },
        recordCode: ECRBRecordCode.CRBA,
    },
};

export { CRBA_DEFAULTS };
